class Video {
  constructor() { // Your code to run since DOM is loaded and ready
    const videos = Array.prototype.slice.call(document.querySelectorAll('.ns-video'));


    videos.forEach(video => {
      const thumbnail = video.querySelector('.ns-video__thumbnail');
      const iframe = video.querySelector('iframe');
      const videoTag = video.querySelector('video');

      thumbnail.addEventListener('click', (e) => {
        if(iframe) {
          iframe.src = iframe.src + '?autoplay=1';
        }else if (videoTag) {
          videoTag.play();
        }

        thumbnail.style.display = 'none';
      });

      // button.addEventListener('click', () => {
      //   const video = button.parentElement;
      //   const thumbnail = button;
      //   const iframe = video.querySelector('iframe');
      //   const link = button.parentElement.nextSibling;
      //   iframe.src = iframe.src + '?autoplay=1';
      //   button.style.display = 'none';
      //   thumbnail.style.display = 'none';
      //   link.style.display = 'none';
      // });
    });

  }
} export default Video;
